import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CuratedRetreatSelection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const isAdminEditMode = () => {
    return typeof window !== 'undefined' && (window as any).WVC_IS_ADMIN_MODE === true;
  };
  const [durations, setDurations] = useState(["6 DIAS / 5 NOITES", "8 DIAS / 7 NOITES", "6 DIAS / 5 NOITES", "7 DIAS / 6 NOITES", "10 DIAS / 9 NOITES", "7 DIAS / 6 NOITES"]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const handleDurationChange = (index: number, value: string) => {
    const filteredValue = value.replace(/[^a-zA-Z0-9\s/]/g, "");
    const newDurations = [...durations];
    newDurations[index] = filteredValue;
    setDurations(newDurations);
  };
  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Enter") {
      setEditingIndex(null);
    } else if (e.key === "Escape") {
      setEditingIndex(null);
    }
  };
  return;
}